import { Injectable } from '@angular/core';
import { Dictionary, FileDataTypesMapSort, SortingTypeEnum } from '@shared';
import { BehaviorSubject, Observable } from 'rxjs';
import { SortingStatus } from './sorting.status';
import { SortingColumn } from './sorting-column';
import { TranslateService } from '@ngx-translate/core';
import { QueryParamsProvider } from '../routing/services';

@Injectable()
export class SortingState {
	private sortingStates: Dictionary<BehaviorSubject<SortingStatus>> = {};
	private defaultSortStatus = new SortingStatus({
		selectedColumn: new SortingColumn({
			isSelected: true,
			displayName: this.translateService.instant('dropdown.lastCreated'),
			name: 'rxdbid',
			dataType: FileDataTypesMapSort.NUMERIC
		}),
		sortDirection: SortingTypeEnum.Ascending
	});

	public constructor(
		private translateService: TranslateService,
		private queryParamsProvider: QueryParamsProvider
	) {}

	public setTableSortState(tableName: string, columnState: SortingStatus) {
		if (this.sortingStates[tableName]) {
			this.sortingStates[tableName].next(columnState);
		} else {
			throw new Error('Sort state should be initialized');
		}
	}

	public resetChildTableSort(): { stopSubscription: () => void } {
		let parentState: SortingStatus;
		const parentStateSubscription = this.getTableSortState(this.queryParamsProvider.parentTableName).subscribe(
			(selectedParentState: SortingStatus) => {
				parentState = selectedParentState;

				Object.keys(this.sortingStates).forEach((key) => {
					if (key !== this.queryParamsProvider.parentTableName) {
						this.sortingStates[key].next(this.defaultSortStatus);
					}
				});
			}
		);

		this.sortingStates[this.queryParamsProvider.parentTableName].next(parentState);
		return {
			stopSubscription: () => parentStateSubscription.unsubscribe()
		};
	}

	public resetParentSort(): void {
		if (this.sortingStates[this.queryParamsProvider.parentTableName]) {
			this.sortingStates[this.queryParamsProvider.parentTableName].next(this.defaultSortStatus);
		}
	}

	public getTableSortState(tableName: string): Observable<SortingStatus> {
		if (!this.sortingStates[tableName]) {
			this.sortingStates[tableName] = new BehaviorSubject(this.defaultSortStatus);
		}

		return this.sortingStates[tableName].asObservable();
	}
}
